<template>
  <div>
    <!-- 搜索 -->
    <div class="search-container">
      <div class="left">
        <!-- 应用类型 -->
        <el-select style="width: 200px; !important;margin-right: 10px;" clearable size="small"
          v-model="searchParams.appType" placeholder="请选择应用类型">
          <el-option label="渠道" value="1"></el-option>
          <el-option label="平台" value="2"></el-option>
        </el-select>
        <!-- 搜索 -->
        <el-input style="width: 300px;" size="small" clearable v-model="searchParams.search"
          placeholder="插件ID/名称/厂商/品牌/型号/UID/UUID"></el-input>
      </div>
      <div class="right">
        <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_SEARCH'" size="small" type="primary"
          @click="search">搜索</el-button>
        <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_ADD'" size="small" @click="add">新增</el-button>
      </div>
    </div>
    <Add ref="addDialog" />
  </div>
</template>

<script>
import Add from "./add.vue";
import Message from "@/components/Message";
export default {
  name: "WebSaaSSearch",
  inject: ["searchParams", "loadList"],
  components: {
    Add,
  },
  data() {
    return {};
  },
  methods: {
    search() {
      Message.success("搜索成功");
      this.loadList()
    },
    add() {
      this.$refs.addDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
  }
}
</style>